var __TEMP__ = require('./_basePick.js');var basePick = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_flatRest.js');var flatRest = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = pick;
